export const Bio = {
  name: "Manisha Gupta",
  roles: [
    "Full Stack Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Manisha6284Gupta",
  resume:
    "https://drive.google.com/file/d/1EO5aooh3bTShJ7lH1aRQ7xvRdqC675_z/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/manisha-gupta-25aa6b281/",
 
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      { name: "React JS", image: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg" },
      { name: "Redux", image: "https://raw.githubusercontent.com/reduxjs/redux/master/logo/logo.png" },
      { name: "HTML", image: "https://upload.wikimedia.org/wikipedia/commons/6/61/HTML5_logo_and_wordmark.svg" },
      { name: "CSS", image: "https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg" },
      { name: "JavaScript", image: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png" },
      { name: "Bootstrap", image: "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png" },
    ],
  },
  {
  title: "Backend",
  skills: [
    { name: "Node JS", image: "https://nodejs.org/static/images/logo.svg" },
    { name: "Express JS", image: "https://upload.wikimedia.org/wikipedia/commons/6/64/Expressjs.png" },
    { name: "PHP", image: "https://upload.wikimedia.org/wikipedia/commons/2/27/PHP-logo.svg" },
    { name: "MongoDB", image: "https://webassets.mongodb.com/_com_assets/cms/mongodb_logo1-76twgcu2dm.png" },
    { name: "MySQL", image: "https://upload.wikimedia.org/wikipedia/en/d/dd/MySQL_logo.svg" },
    { name: "Firebase", image: "https://www.gstatic.com/mobilesdk/160503_mobilesdk/logo/2x/firebase_28dp.png" },
  ],
},
{
  title: "App Development",
  skills: [
    {
      name: "Java",
      image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
    },
    {
      name: "React Native",
      image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
    },
    {
      name: "Android Studio",
      image: "https://upload.wikimedia.org/wikipedia/commons/3/34/Android_Studio_logo.png",
    },
  ],
},
  {
    title: "AI & ML",
    skills: [
      { name: "Python", image: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg" },
      { name: "TensorFlow", image: "https://upload.wikimedia.org/wikipedia/commons/2/2d/Tensorflow_logo.svg" },
      { name: "Scikit-learn", image: "https://upload.wikimedia.org/wikipedia/commons/0/05/Scikit_learn_logo_small.svg" },
      { name: "Pandas", image: "https://upload.wikimedia.org/wikipedia/commons/e/ed/Pandas_logo.svg" },
      { name: "NumPy", image: "https://upload.wikimedia.org/wikipedia/commons/3/31/NumPy_logo_2020.svg" },
      { name: "Matplotlib", image: "https://upload.wikimedia.org/wikipedia/commons/8/88/Matplotlib_logo.svg" },
    ],
  },
  {
  title: "Other Tools",
  skills: [
    {
      name: "Git",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
    },
    {
      name: "GitHub",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
    },
    {
      name: "Canva",
      image: "https://upload.wikimedia.org/wikipedia/commons/3/3b/Canva_Logo.png",
    },
    {
      name: "Excel",
      image: "https://upload.wikimedia.org/wikipedia/commons/7/73/Microsoft_Excel_2013_logo.svg",
    },
    {
      name: "Google Sheets",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg",
    },
    {
      name: "VS Code",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
    },
    {
      name: "Postman",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postman/postman-original.svg",
    },
    {
  name: "Vercel",
  image: "https://assets.vercel.com/image/upload/front/favicon/vercel/180x180.png",
},
    {
      name: "Figma",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
    },
    {
      name: "Netlify",
      image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/netlify/netlify-original.svg",
    },
    {
  name: "Power BI",
  image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/powerbi/powerbi-original.svg",
}
  ],
}
];







export const experiences = [
  {
    id: 0,
    img: "CSIRlogo.jfif",
    role: "Trainee",
    company: "Council of Scientific & Industrial Research",
    date: "June 2024 - July 2024",
    desc: "Completed a research internship at CSIR, working on applying theoretical concepts to real-world scientific problems. Gained hands-on experience in data analysis, research experimentation, documentation, and technical problem-solving under the guidance of experienced scientists.",
    skills: [
      "Data Analysis",
      "Research & Experimentation",
      "Result Evaluation",
      "Analytical Thinking",
      "Problem Solving",
    ],
    doc: "", // optional: add certificate link if available
  },
  {
    id: 1,
    img: "Axcentra.jfif",
    role: "Web Development Intern",
    company: "Axcentra",
    date: "Aug 2024 - Oct 2024",
    desc: "Worked on front-end development projects, focusing on building responsive web pages and improving user interface designs. Collaborated with the team to implement modern web standards and best practices.",
    skills: ["HTML", "CSS", "JavaScript", "Responsive Design"],
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1696514649120.jpeg?alt=media&token=e7f6757b-edfa-4138-a692-d6709eeef3e2",
  },
  {
    id: 2,
    img: "gndeclogo.png",
    role: "Trainee",
    company: "Guru Nanak Dev Engineering College",
    date: "June 2025 - July 2025",
    desc: "Developed a fully functional Scholarship Management System to automate the end-to-end scholarship process, including registration, application submission, verification, and approval. Enhanced transparency and efficiency for both students and administrators using role-based access.",
    skills: ["ReactJs", "NodeJs", "MongoDB", "Express", "UI/UX Design"],
    doc: "", // optional certificate link
  },
  {
    id: 3,
    img: "dcoffice logo.png",
    role: "District Technological Intern",
    company: "DC Office Ludhiana, Punjab",
    date: "Jan 2026 - Present",
    desc: "Contributing to open-source and government technology projects while gaining practical experience in real-world software development, data handling, and process optimization. Collaborating with industry professionals and improving technical skills.",
    skills: ["ReactJs", "NodeJs", "Full Stack Development", "Project Collaboration"],
    doc: "", // optional
  },
];



export const education = [
  {
    id: 0,
    img: "gndeclogo.png",
    school: "Guru Nanak Dev Engineering College, Ludhiana",
    date: "Oct 2022 - Sep 2026",
    grade: "8.5 CGPA",
    degree: "Bachelor of Technology (B.Tech) in Computer Science and Engineering",
    desc: "Pursuing a B.Tech in Computer Science and Engineering at GNDEC, Ludhiana. Completed 7 semesters with a CGPA of 8.5. Coursework includes Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks. Gained hands-on experience in software development, problem-solving, and research-based projects."
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRy8N8FZq3bA2rVjemA1EmGBSPVRrUm9mea6hcTSYw3g&s",
    school: "Shaheed-e-Azam Sukhdev Thaper Senior Secondary School, Bharat Nagar",
    date: "Apr 2021 - Apr 2022",
    grade: "95%",
    degree: "PSEB (XII), Science with Computer Science",
    desc: "Completed class 12 with a focus on Science and Computer Science. Developed foundational skills in mathematics, physics, chemistry, and programming, achieving an aggregate of 95%."
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRy8N8FZq3bA2rVjemA1EmGBSPVRrUm9mea6hcTSYw3g&s", // Optional placeholder
    school: "Shaheed-e-Azam Sukhdev Thaper Senior Secondary School, Bharat Nagar",
    date: "Apr 2019 - Mar 2021",
    grade: "95%",
    degree: "PSEB (X)",
    desc: "Completed high school education with a focus on Science. Developed strong analytical and logical reasoning skills, scoring 95% overall."
  }
];














// https://github.com/Manisha6284Gupta/resume_new






export const projects = [
  {
    id: 11,
    title: "Resume Building",
    date: "Jan 2023 - Dec 2023",
    description:
      "Decision Hub is a no-code Rule Builder project developed to help Business Analysts create, manage, and visualize decision strategies without writing code. Users can define business rules, execute them in real time, and track calculations at each decision step. It simplifies complex business logic, improves transparency, and enables faster validation of business rules.",
    image: "ResumeBuilding.png",
    tags: ["React.js", "PostgreSQL", "Node.js", "Express.js", "Redux", "React Flow"],
    category: "Web App",
    github: "https://github.com/Manisha6284Gupta/Resume_Building",
    webapp: "https://resume-new-khv8.vercel.app/"
  },
  {
    id: 9,
    title: "Scholarship System for GNDEC",
    date: "Jun 2025 - Nov 2025",
    description:
      "Web-based application to streamline scholarship management within GNDEC. Role-based access allows students to apply, teachers to verify, and admins to approve, track, and manage records efficiently. Automates eligibility checks, application workflows, and status tracking to reduce manual effort and improve transparency.",
    image: "gneProject.png",
    tags: ["CI/CD", "React.js", "MongoDB", "Node.js", "Express.js", "Redux"],
    category: "Web App",
    github: "https://github.com/username/scholarship-system",
    webapp: "https://trackify-management.netlify.app/"
  },
  {
    id: 0,
    title: "Portfolio",
    date: "Dec 2024 - Jan 2025",
    description:
      "Personal Portfolio Website to showcase projects, skills, and professional profile. Includes sections for About Me, Resume, Projects, Skills, and links to GitHub, LinkedIn, and other platforms. Demonstrates front-end development, UI/UX design, and web technologies.",
    image: "portfoilo.png",
    tags: ["React.js", "MongoDB", "Node.js", "Express.js", "Redux"],
    category: "Web App",
    github: "https://github.com/Manisha6284Gupta/Portfolio_with_mern",
    webapp: "https://portfolio-with-mern-one.vercel.app/"
  },
  {
    id: 1,
    title: "EduPlan",
    date: "Jan 2026 - Feb 2026",
    description:
      "EduPlan is a district-level education management system for teachers and education heads. Teachers upload weekly teaching schedules and lesson plans, while administrators review and monitor academic activities to ensure proper curriculum implementation.",
    image: "edu.png",
    tags: ["React.js", "MongoDB", "Node.js", "Express.js", "Redux", "NodeMailer"],
    category: "Web App",
    github: "https://github.com/Manisha6284Gupta/EduPlan",
    webapp: "https://vexa-app.netlify.app/"
  },
  {
    id: 2,
    title: "Codify",
    date: "Oct 2025 - Jan 2026",
    description:
      "Vexa project management app for users and teams to stay organized. Features include task tracking, team collaboration, time tracking, member invitations, and plans for community interaction and chat system integration.",
    image: "Codify.png",
    tags: ["React.js", "MongoDB", "Node.js", "Express.js", "Redux", "NodeMailer"],
    category: "Web App",
    github: "https://github.com/Manisha6284Gupta/InterviewCallingPlatform",
    webapp: "https://vexa-app.netlify.app/"
  },
  {
    id: 3,
    title: "Flappy Bird AI",
    date: "Jan 2023 - Mar 2023",
    description:
      "Developed a machine learning model to detect brain tumors from medical images. Preprocessed and augmented data, trained the model, created API using Python, and built a React front-end. Achieved 99.2% accuracy in tumor detection.",
    image: "flappybird.png",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React.js"],
    category: "Machine Learning",
    github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
    webapp: "https://brain-tumor.netlify.app/"
  },
  {
    id: 4,
    title: "Rock, Scissor & Paper",
    date: "Dec 2021 - Apr 2022",
    description:
      "Android app for personal expense tracking with Google Drive backup. Built in Kotlin using MVVM architecture and LiveData. Achieved 100+ downloads on Play Store.",
    image: "RockPapper.png",
    tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
    category: "Android App",
    github: "https://github.com/rishavchanda/Buckoid-Android-App",
    webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid"
  },
  {
  id: 5,
  title: "DC Dashboard (District Collector Dashboard)",
  date: "Jan 2026 - Present",
  description:
    "A centralized administrative dashboard built to manage and monitor citizen complaints, service requests, and public grievances. The system enables real-time tracking, data visualization, role-based access control, and status updates between citizens and district officials. Designed to improve transparency, efficiency, and response time in governance.",
  image: "dc_dashboard.png",
  tags: ["React.js", "Node.js", "Express.js", "MongoDB", "REST API"],
  category: "web app",
  github: "https://github.com/Manisha6284Gupta/DC_Dashboard",
  webapp: "https://your-live-link.com"
}
]
  